import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth-service';
import { tenant } from '../../../tenants/tenant';

export const authGuard: CanActivateFn = async (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  try {
    const isAuthenticated = await authService.waitForAuthCheck();

    if (isAuthenticated) {
      if (!authService.user()) {
        await authService.getCurrentUser();
      }

      const aligned = await authService.ensureUserAlignment();
      if (!aligned) {
        return router.createUrlTree(['/error-page']);
      }

      await authService.ensureUserProfile();

      return true;
    }

    if (tenant.samlEnabled) {
      await authService.loginWithSaml();
      return false;
    }

    return router.createUrlTree(['/login']);
  } catch (error) {
    console.error('Auth guard error:', error);
    if (tenant.samlEnabled) {
      return router.createUrlTree(['/error-page']);
    }
    return router.createUrlTree(['/login']);
  }
};
